// @core/api/endpoints/audittrail/record_audit_event.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AuditRecordResponse,
  RecordAuditEventRequest,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Record an audit event
 * Creates an immutable audit record with hash chain linking. The record is appended to the tenant's audit chain and its hash is computed from the previous record's hash.
 */
export async function RecordAuditEvent(
  data: RecordAuditEventRequest,
  options?: RequestOptions
): Promise<AuditRecordResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit/records`;
  const requestOptions = options;
  return client.post<AuditRecordResponse>(requestPath, data, requestOptions);
}
